import Logo from "@/components/Logo";
import { BRANDING } from "@/config/branding";

export default function LoginHeader() {
  return (
    <div className="mb-8 flex w-full max-w-md justify-center rounded-xl bg-white p-6 shadow-lg sm:p-8">
      <Logo />
    </div>
  );
}
